import React, { useRef, useEffect, useState } from "react";
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from "mapbox-gl";

import * as Styled from "./styles.js";

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2lkZW9uanIiLCJhIjoiY2tudmdlZTZhMDJmYTJvbjRiaHpmcHl3ZyJ9.KxGzrM1ZHq9NwEkXOJz7ZA";

const Map = () => {
  const mapContainerRef = useRef(null);

  const [lng, setLng] = useState(-87.6298);
  const [lat, setLat] = useState(41.8781);
  const [zoom, setZoom] = useState(10);

  // Initialize map when component mounts
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
    });

    map.once("load", () => {
      map.addSource("afam_sites", {
        type: "geojson",
        data: "https://goij-general-assets.s3.amazonaws.com/afam_sites.geojson",
      });

      map.addLayer({
        id: "trailheads-circle",
        type: "circle",
        source: "afam_sites",

        paint: {
          "circle-color": "hsla(0,0%,0%,0.75)",
          "circle-stroke-width": 1.5,
          "circle-stroke-color": "white",
        },
      });
    });

    map.on("move", () => {
      setLng(map.getCenter().lng.toFixed(4));
      setLat(map.getCenter().lat.toFixed(4));
      setZoom(map.getZoom().toFixed(2));
    });

    return () => map.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Styled.MapSidebar>
        <div>
          Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
        </div>
      </Styled.MapSidebar>
      <Styled.MapContainer ref={mapContainerRef} />
    </div>
  );
};

export default Map;
